const keyClean = 'modal-clean__code';

export { keyClean };
